module.exports = __webpack_public_path__ + "components/rewards/sport-pursuit/static/icon-abd7251065bb4b12d4d84c05f7938036.svg";